export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/male_icon.b19a6a71.svg","height":19,"width":13,"blurWidth":0,"blurHeight":0};